/**
 * Aba "Centros de custo" de /financeiro/cadastros · redesign FIN-7.
 * Tabela .dtable (fiel ao mockup). CRUD e endpoints inalterados.
 */
import React, { useCallback, useEffect, useState } from "react";
import { FiEdit2, FiPlus } from "react-icons/fi";

import AsyncButton from "../../../components/AsyncButton";
import SlideOverPanel from "../../../components/SlideOverPanel";
import { useAuth } from "../../../context/AuthContext";
import {
  atualizarCentro, criarCentro, desativarCentro, listarCentros,
} from "../../../services/financeiro";
import { Input, SecondaryButton, Textarea } from "../../Orcamentos/styles";


function CentroForm({ inicial, onSave, onCancel, onDelete, unidadeId }) {
  const [dados, setDados] = useState({
    nome: inicial?.nome || "",
    descricao: inicial?.descricao || "",
  });
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
      <label style={{ display: "flex", flexDirection: "column", gap: 4 }}>
        <span style={{ fontSize: 12, fontWeight: 600 }}>Nome *</span>
        <Input value={dados.nome} onChange={(e) => setDados({ ...dados, nome: e.target.value })} maxLength={120} />
      </label>
      <label style={{ display: "flex", flexDirection: "column", gap: 4 }}>
        <span style={{ fontSize: 12, fontWeight: 600 }}>Descrição</span>
        <Textarea rows={2} value={dados.descricao} onChange={(e) => setDados({ ...dados, descricao: e.target.value })} />
      </label>
      <div style={{ display: "flex", gap: 8, justifyContent: "flex-end", alignItems: "center" }}>
        {onDelete && <AsyncButton variant="danger" silentSuccess onClick={onDelete} style={{ marginRight: "auto" }}>Desativar</AsyncButton>}
        <SecondaryButton onClick={onCancel}>Cancelar</SecondaryButton>
        <AsyncButton variant="primary" onClick={() => onSave({ ...dados, unidade: unidadeId })} successMessage="Centro salvo">Salvar</AsyncButton>
      </div>
    </div>
  );
}


export default function CentrosTab() {
  const { request, hasAllPermissions, isMaster } = useAuth();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [editando, setEditando] = useState(null);
  const [unidadeId, setUnidadeId] = useState("");

  const podeManage = isMaster || hasAllPermissions(["financeiro:configurar"]);

  const carregar = useCallback(async () => {
    setLoading(true); setError(null);
    try {
      const p = await listarCentros(request);
      const list = Array.isArray(p) ? p : p?.results || [];
      setItems(list);
      if (list.length > 0 && !unidadeId) setUnidadeId(list[0].unidade);
    } catch (err) {
      setError(err?.message || "Erro.");
    } finally { setLoading(false); }
  }, [request, unidadeId]);

  useEffect(() => { carregar(); }, [carregar]);

  useEffect(() => {
    if (unidadeId) return;
    request("/api/unidades").then((d) => {
      const list = Array.isArray(d) ? d : d?.results || [];
      if (list.length > 0) setUnidadeId(list[0].id);
    }).catch(() => {});
  }, [request, unidadeId]);

  const handleSalvar = async (dados) => {
    if (editando === "novo") await criarCentro(request, dados);
    else await atualizarCentro(request, editando.id, dados);
    setEditando(null);
    await carregar();
  };

  const handleExcluir = async (c) => {
    if (!window.confirm(`Desativar centro "${c.nome}"?`)) return;
    await desativarCentro(request, c.id);
    setEditando(null);
    await carregar();
  };

  return (
    <>
      <div className="flex between" style={{ marginBottom: 12, alignItems: "center" }}>
        <span className="tiny mono muted">{loading ? "Carregando…" : `${items.length} centro(s)`}</span>
        {podeManage && (
          <button type="button" className="btn btn--primary btn--sm" onClick={() => setEditando("novo")}>
            <FiPlus size={14} aria-hidden="true" /> Novo centro
          </button>
        )}
      </div>
      {error && <div className="empty"><div className="msg">{error}</div></div>}

      <div className="table-wrap">
        <table className="dtable">
          <colgroup><col style={{ width: "30%" }} /><col /><col style={{ width: 90 }} /><col style={{ width: 48 }} /></colgroup>
          <thead><tr><th>Centro de custo</th><th>Descrição</th><th>Status</th><th></th></tr></thead>
          <tbody>
            {items.length === 0 && (
              <tr><td colSpan={4} style={{ padding: 0 }}><div className="empty"><div className="msg">{loading ? "Carregando…" : "Nenhum centro de custo."}</div></div></td></tr>
            )}
            {items.map((c) => (
              <tr key={c.id}>
                <td><strong>{c.nome}</strong></td>
                <td className="ell" title={c.descricao}>{c.descricao || "—"}</td>
                <td><span className={"badge no-dot " + (c.ativo ? "success" : "neutral")}>{c.ativo ? "Ativo" : "Inativo"}</span></td>
                <td>
                  {podeManage && (
                    <button type="button" className="icon-btn" style={{ width: 28, height: 28 }}
                            aria-label="Editar" onClick={() => setEditando(c)}><FiEdit2 size={13} aria-hidden="true" /></button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {editando && (
        <SlideOverPanel open onClose={() => setEditando(null)}
                        title={editando === "novo" ? "Novo centro" : `Editar ${editando.nome}`}>
          <CentroForm inicial={editando === "novo" ? null : editando}
                      onSave={handleSalvar} onCancel={() => setEditando(null)}
                      onDelete={editando !== "novo" && editando.ativo ? () => handleExcluir(editando) : undefined}
                      unidadeId={unidadeId} />
        </SlideOverPanel>
      )}
    </>
  );
}
